/**
 * Filter options for the global subscriptions admin list.
 * The empty string value means "no filter" — the hook strips it before sending to the API.
 */
export const STATUS_FILTER_OPTIONS = [
    { value: "", label: "Tous statuts" },
    { value: "pending", label: "En attente" },
    { value: "active", label: "Actif" },
    { value: "expired", label: "Expiré" },
    { value: "cancelled", label: "Annulé" },
];

export const OWNER_TYPE_FILTER_OPTIONS = [
    { value: "", label: "Tous propriétaires" },
    { value: "user", label: "Utilisateur" },
    { value: "artist_group", label: "Groupe" },
    { value: "entity", label: "Entité" },
];

export const TIER_FILTER_OPTIONS = [
    { value: "", label: "Tous types" },
    { value: "blue", label: "Blue" },
    { value: "violet", label: "Violet" },
    { value: "silver_star", label: "Silver Star" },
    { value: "vip", label: "VIP" },
];

export const PROVIDER_FILTER_OPTIONS = [
    { value: "", label: "Tous paiements" },
    { value: "stripe", label: "Stripe (récurrent)" },
    { value: "orange_money", label: "Orange Money (prépayé)" },
];

/**
 * Owner type labels used in OwnerCell when the API returns just the enum value.
 */
export const OWNER_TYPE_LABELS = {
    user: "Utilisateur",
    artist_group: "Groupe",
    entity: "Entité",
};

/** Default page size for the global list (mirrors the API default). */
export const SUBSCRIPTIONS_PAGE_SIZE = 20;
